<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
            <div class="card-header card-header-with-button">
               <h5>{{$t('STEP')}}</h5>
                <div>
                    <button type="button" class="btn-bis btn-primary mr-2" @click="copyAll">{{$t('COPYALL')}}</button>
                    <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
               </div>            </div>

            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th>
                        <b-form-checkbox
                            v-model="selectAll"
                            :value="true"
                            :unchecked-value="false"
                            v-on:input="toggleAll">
                        </b-form-checkbox>
                    </th>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('ORDERNUM')}}</th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <draggable v-model="data.root" @start="drag=true" @end="drag=false" @change="changeOrder" tag="tbody">
                  <template v-for="(item, key) in data.root">
                    <tr :key="item.stepId" aria-rowindex="1" class=" table-ellipsis" :class="(item.hasStep > 0) ? '' : ' invalid'">
                        <td>
                            <b-form-checkbox
                                v-model="selectedData[key]"
                                :value="true"
                                :unchecked-value="false">
                            </b-form-checkbox>
                        </td>
                        <td>{{item.name}}</td>
                        <td>{{item.orderNum}}</td>
                        <td class="table-buttons">
                            <b-button type="reset" class="btn-table table-btn-secondary" @click="showDetails(item)">{{$t('STEPBUTTONS')}}</b-button>
                            <b-button type="reset" class="btn-table table-btn-secondary ml-2" @click="showQuestions(item)">{{$t('QUESTIONS')}}</b-button>
                            <b-button type="reset" class="btn-table table-btn-secondary ml-2"  @click="copy(item.stepId)">{{$t('COPY')}}</b-button>
                            <b-button type="reset" class="btn-table table-btn-tertiary ml-2"  @click="showModal(item)">{{$t('EDIT')}}</b-button>
                            <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteStep(item.stepId)">{{$t('DELETE')}}</b-button>
                        </td>
                    </tr>
                  </template>
                </draggable>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <b-modal ref="formmodal" centered ok-title="submit" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('STEPFORM')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="hideModal()" class="close"><img src="../../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
            <stepform v-bind:formData="formData" v-bind:formError="formError"></stepform>

            <div class="text-center mt-lg">
                <b-btn class="mr-2 btn-bis btn-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
                <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/flow/Step.js';
import QuestionApi from '@/api/flow/Questions.js';
import StepButtonsApi from '@/api/flow/StepButton.js';
import StepForm from './Form.vue';

export default {
    name: 'Step',
    components:
    {
        stepform: StepForm,
    },
    data()
    {
        const me = this;

        me.formDataField = {
            name: '',
            orderNum: 0,
        };

        return {
            loading: true,
            selectAll: false,
            selectedData: {},
            data: {},
            formError: {},
            formData: {...me.formDataField},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
                initialId: null,
                sort: null,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async copyAll()
      {
          const me = this;

          const data = [];

            for (const item of me.data.root)
            {
                if (me.selectedData[me.data.root.indexOf(item)])
                {
                    data.push(item.stepId);
                }
            }

            if (data.length > 0)
            {
                me.$store.commit('setModalAlert',
                {
                    text: me.$i18n.t('AREYOUSHUREYOUWANTTOCOPYSTEPS'),
                    async btnAction()
                    {
                        me.loading = true;
                        const response = await Api.copyAll({stepIds: data});
                        me.$notify.notice(response);
                        me.getData();
                    },
                });
            }
      },
      toggleAll()
    {
        const me = this;

        for (let i = 0; i < me.data.root.length; i += 1)
        {
            me.selectedData[i] = me.selectAll;
        }

        // eslint-disable-next-line prefer-object-spread
        me.selectedData = Object.assign({}, me.selectedData);
    },
      showDetails(item)
      {
          const me = this;
          me.$router.push(
              {
                  path: `/flowsec/step/${me.$route.params.flowId}/step_buttons/${item.stepId}`,
                  query: { flowName: me.$route.query.flowName, stepName: item.name },
              },
          );
      },
      showQuestions(item)
      {
          const me = this;
          me.$router.push(
              {
                  path: `/flowsec/step/${me.$route.params.flowId}/questions/${item.stepId}`,
                  query: { flowName: me.$route.query.flowName, stepName: item.name },
              },
          );
      },
      async copy(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHUREYOUWANTTOCOPYSTEP'),
                  async btnAction()
                  {
                      const data = await Api.copy({id: id});
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              me.selectedData = {};
              me.selectAll = false;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async changeOrder(item)
        {
            const me = this;
            try
            {
                const { moved } = item;

                const movedData = moved.element;

                let newIndex = moved.newIndex * 10 + 1;

                if (moved.newIndex === me.data.root.length - 1)
                {
                    newIndex += 10;
                }

                const data = await Api.save(
                    {
                        id: movedData.stepId,
                        orderNum: newIndex,
                    },
                );
                me.$notify.notice(data);
                me.getData();
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        async deleteStep(id)
        {
            const me = this;

            me.$store.commit('setModalAlert',
            {
                text: me.$i18n.t('AREYOUSHURE'),
                async btnAction()
                {
                    /* first delete questions with that step id because of constraints */
                    const questionsResponse = await QuestionApi.selectRow({
                        ...me.getQuestionParams,
                        stepId: id,
                    });
                    
                    const questions = questionsResponse.root;

                    Promise.all(questions.map(async (question) => {
                        return await QuestionApi.deleteRow({
                            id: question.questionsId,
                        });
                    }));

                    /* then delete all step buttons */
                    const stepButtonsResponse = await StepButtonsApi.selectRow({
                        ...me.getStepButtonsParams,
                        stepId: id,
                    });
                    
                    const stepButtons = stepButtonsResponse.root;

                    Promise.all(stepButtons.map(async (stepButton) => {
                        return await StepButtonsApi.deleteRow({
                            id: stepButton.stepButtonId,
                        });
                    }));

                    /* finally, delete step */
                    const data = await Api.deleteRow({ id });
                    me.$notify.notice(data);
                    me.getData();
                },
            });
        },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = { ...item };
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              me.loading = true;
              if (typeof item.stepId !== 'undefined')
              {
                  item.id = item.stepId;
                  delete (item.stepId);
              }

              item.flowId = me.$route.params.flowId;
              const data = await Api.save(item);
              if (data.error)
              {
                  me.formError = data;
                  throw (data);
              }

              me.$notify.notice(data);
              me.getData();
              me.hideModal();
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      hideModal()
      {
          const me = this;

          me.formError = {};
          me.formData = {...me.formDataField},
          this.$refs.formmodal.hide();
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.flowId = me.$route.params.flowId;
          return data;
      },
      getQuestionParams()
      {
          const data = {};
          data.start = 0;
          data.limit = 100;
          data.searchTimeout = false;
          data.query = '';
          return data;
      },
      getStepButtonsParams()
      {
          const data = {};
          data.start = 0;
          data.limit = 100;
          data.searchTimeout = false;
          data.query = '';
          return data;
      },
  },
};
</script>
